<template>
  <div class="free" :style="styleObject" v-if="isShow">
    <!-- <p class="title">易纸箱，为纸箱厂量身定制的数字化解决方案</p> -->
    <div class="btn-group">
      <dj-button
        v-for="(item, index) in freeUse.freeUses"
        :key="index"
        :href="item.link ? item.link : 'javascript:void(0)'"
        :target="item.link ? '_blank' : '_self'"
        type="light"
        class="btn"
        @click.native="handleBtnClick(item.name)"
      >
        {{ item.name }}
      </dj-button>
    </div>
  </div>
</template>

<script>
import { getProductDetailById } from '@/api/product.js'
import utils from '@/utils/utils'

export default {
  name: 'free',
  props: {},
  data() {
    return {
      // 产品详情
      product: {},
      // 背景图配置
      styleObject: {},
      // 免费试用按钮配置
      freeUse: {
        picList: [],
        freeUses: []
      }
    }
  },
  computed: {
    isShow() {
      // 1-免费试用
      const data = this.product && this.product.displayModule && this.product.displayModule.includes(1)
      return data
    }
  },
  created() {
    this.getProductDetailById()
  },
  methods: {
    /**
     * 获取产品详情-包含免费试用数据
     */
    getProductDetailById() {
      getProductDetailById().then((res) => {
        if (res.success) {
          this.product = res.data;
          this.freeUse = {
            ...this.freeUse,
            ...(res.data.freeUse || {})
          }
          this.getPicList()
          this.getFreeUses()
        }
      })
    },
    /**
     * 获取背景图配置
     */
    getPicList() {
      if (!this.freeUse.picList.length) return
      this.styleObject = {
        backgroundImage: `url(${utils.setOssUrl(
          this.freeUse.picList[0].picture
        )})`
      }
    },
    /**
     * 获取免费试用按钮配置
     */
    getFreeUses() {
      this.freeUse.freeUses =
        this.freeUse.freeUses.filter((v) => Object.is(v.buttonStatus, 'y')) ||
        []
    },
    /**
     * 按钮点击事件
     */
    handleBtnClick(name) {
      const params = {
        officialSite_e_name: name,
        officialSite_e_freeUseDetailsSource: 'advert',
        officialSite_e_productName: this.$store.getters.getProductBasicInfo.productName,
      }
      this.$sensors.officialSite_FreeUseDetails(params)
    },
  }
}
</script>

<style scoped lang="scss">
.free {
  width: 100%;
  height: 281px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url('../../../assets/images/bg_default_all.png');
  background-position: center;
  background-size: cover;
  .title {
    font-size: 28px;
    font-weight: 500;
    color: #fff;
    line-height: 45px;
  }
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    .btn {
      margin-right: 24px;
    }
  }
}
@media (min-width: 750px) and (max-width: 960px) {
}
@media (min-width: 961px) {
}
</style>
